import { useEffect, useState } from "react";

export const useWindowWidth = () => {
    const [width, setWidth] = useState(window.innerWidth);
  
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
  
      window.addEventListener('resize', handleResize);
  
      // Sprzątanie po komponentach
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return width;
  };